import { round } from 'lodash';

export const binMap: { [key: string]: Array<number> } = {
  MPH: [7, 12, 18, 24],
  KTS: [6, 10, 16, 21],
  KPH: [11, 19, 29, 39],
};

export const getMaxWindSpeedBinValue = (maxWindSpeed: number, units: string) => {
  const bins = binMap[units] || [];
  return bins.find((bin: number) => maxWindSpeed <= bin) || round(maxWindSpeed, 0);
};

const scaleLinearWindSpeed = (windSpeedBinValue: number, windSpeed: number, maxPixels: number) =>
  (maxPixels * windSpeed) / windSpeedBinValue;

const scaleWindSpeed = (
  maxWindSpeed: number,
  windSpeed: number,
  units: string,
  maxPixels: number = 140,
) => {
  const maxWindSpeedBinValue = getMaxWindSpeedBinValue(maxWindSpeed, units);
  // return height in pixels
  return scaleLinearWindSpeed(
    maxWindSpeedBinValue,
    round(windSpeed) === 0 ? 0 : windSpeed,
    maxPixels,
  );
};

export default scaleWindSpeed;
